import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: François Risoud
 * id 5F4F40C3-F04B-47BE-BB4F-13F080A81C6A
 * name filter-variant-plus
 * version: 4.3.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/filter-variant-plus.svg
 * tags
 */
export const FilterVariantPlusIcon = createSvgIcon(<><path d="M21 8H3V6H21V8M13.81 16H10V18H13.09C13.21 17.28 13.46 16.61 13.81 16M18 11H6V13H18V11M18 15V18H15V20H18V23H20V20H23V18H20V15H18Z" /></>, 'FilterVariantPlusIcon');
export default FilterVariantPlusIcon